import { useEffect } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  BROADCAST_LIST,
  GET_PREV_NEXT_BROADCAST_LIST,
  MORE_BROADCAST_LIST_INDEX,
  SELECTED_BROADCAST_DATE,
} from 'core/store/broadcastTable'

/**
 * 이전 / 다음 일자의 방송 목록 fetch hook
 */
export default function usePrevNextBroadcastList() {
  const selectedDate = useRecoilValue(SELECTED_BROADCAST_DATE)
  const data = useRecoilValue(GET_PREV_NEXT_BROADCAST_LIST(selectedDate))
  const [broadcastList, setBroadcastList] = useRecoilState(BROADCAST_LIST(selectedDate))
  const setMoreListIndex = useSetRecoilState(MORE_BROADCAST_LIST_INDEX)

  useEffect(() => {
    if (!data || !data.items) return

    setBroadcastList(data.items)
    /**
     * moreListIndex를 fromNow 배열의 length로 초기화
     */
    setMoreListIndex(data.items.fromNow.length)
  }, [data, setBroadcastList, setMoreListIndex])

  return broadcastList
}
